import { type FunctionComponent } from "react";
import type { UsedSource } from "@noa/api-core";
import { buildDocumentUrl } from "../../../utils/document-url.utils";
import { LinkDocInfoPopover } from "./link-doc-info-popover";

interface LinkDocInfoProps {
  refNumber: number;
  used_sources?: UsedSource;
}

export const LinkDocInfo: FunctionComponent<LinkDocInfoProps> = ({ refNumber, used_sources }) => {
  if (!used_sources) {
    return null;
  }

  const { source_url, source_document_name, unique, location_information } = used_sources;

  const href = buildDocumentUrl(source_url, location_information) || `#${refNumber}`;
  const displayText = source_document_name || unique;

  return (
    <LinkDocInfoPopover used_sources={used_sources} href={href}>
      <div style={{ marginLeft: "16px" }}>
        {displayText} {location_information ?? ""}
      </div>
    </LinkDocInfoPopover>
  );
};
